import React from "react"

export const PDFPreview = ({ data }) => {
  const { pdf, mobile } = data

  if (mobile) {
    return (
      <div className="pdf-preview">
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(pdf)}&embedded=true`}
          width="100%"
          height="600"
          title="PDF preview"
        />
      </div>
    )
  }

  return (
    <div className="pdf-preview">
      <iframe
        src={pdf}
        width="100%"
        height="600"
        title="PDF preview"
      />
    </div>
  )
}